import SteakImage1 from '../images/foodImages/steak/Steak_img1.jpg';

const SteakItems = [
  {
    id: 1,
    name: '上天給的禮物',
    price: 230,
    description: '新鮮蔬菜，清爽口感，營養豐富。',
    image: SteakImage1,
  },
  {
    id: 2,
    name: '敘月招牌烤雞腿',
    price: 280,
    description: '外脆內嫩的招牌雞腿，展現原味美味。',
    image: SteakImage1,
  },
  {
    id: 3,
    name: '不被炒魷魚',
    price: 320,
    description: '鮮嫩魷魚，簡單調味，保留海味精華。',
    image: SteakImage1,
  },
  {
    id: 4,
    name: '真的很蝦ㄟ',
    price: 350,
    description: '完美煎蝦，保持鮮嫩口感，原汁原味。',
    image: SteakImage1,
  },
  {
    id: 5,
    name: '彈牙豬(松阪豬)',
    price: 380,
    description: '松阪豬肉，彈嫩多汁，肉香四溢。',
    image: SteakImage1,
  },
  {
    id: 6,
    name: '鮭魚排',
    price: 380,
    description: '外脆內嫩鮭魚，天然鮮味，滑嫩可口。',
    image: SteakImage1,
  },
  {
    id: 7,
    name: '非常牛(牛板腱)',
    price: 400,
    description: '鮮嫩牛板腱，肉香四溢，每口都享受。',
    image: SteakImage1,
  },
  {
    id: 8,
    name: '海派(綜合海鮮)',
    price: 420,
    description: '多樣新鮮海鮮，豐富口感，海味十足。',
    image: SteakImage1,
  },
  {
    id: 9,
    name: '鮮嫩巴沙魚',
    price: 280,
    description: '綿密細膩的巴沙魚，口感柔順清新。',
    image: SteakImage1,
  },
];

export default SteakItems;
